import React from 'react'

const EventRegistration = () => {
  return (
    <div>EventRegistration</div>
  )
}

export default EventRegistration